import React from 'react';
import ArticleStockButtonProperties from "./ArticleStockButtonProperties";
import {useI18nContext} from "../../../contexts/I18nContext";
import RoundedButton from "../../../ui_components/RoundedButton/RoundedButton";
import {Observer} from "mobx-react-lite";
import {useStyles} from "./ArticleStockButton.style";
import Button from "../../../ui_components/Button/Button";
import ButtonType from "../../../ui_components/Button/ButtonType";
import {useCommonContext} from "../../../contexts/CommonContext";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import Box from "../../../ui_components/Box/Box";
import Width from "../../../ui_components/common/enums/Width";
import Alignment from "../../../ui_components/common/enums/Alignment";
import ShowPagination from "../../../ui_components/ShowPagination/ShowPagination";
import MessageCard from "../../../ui_components/MessageCard/MessageCard";
import SidePanel from '../../../ui_components/SidePanel/SidePanel';
import ShowSellerBasicInfo from '../../Info/ShowSellerBasicInfo/ShowSellerBasicInfo';
import { useUserContext } from '../../../contexts/UserContext';
import Access from '../../Access/AllowAccess/Access';
import ArticleStockStore from './ArticleStockStore';
import clsx from 'clsx';
import InventoryIcon from '@mui/icons-material/Inventory';
import Link from '../../../ui_components/Link/Link';
import ShowArticleStockLocation from '../../Info/ShowArticleStockLocation/ShowArticleStockLocation';
import ShowArticleStock from '../../Info/ShowArticleStock/ShowArticleStock';

const ArticleStockButton: React.FC<ArticleStockButtonProperties> = ({
                                                                          onClick = () => {
                                                                          },
                                                                          showIcon = true,
                                                                          showText = true,
                                                                          isLinkText = false,
                                                                          disabled,
                                                                          className = '',
                                                                          articleId,
                                                                          rounded = false,
                                                                          size = ButtonSize.DEFAULT,
                                                                          type = ButtonType.DEFAULT
                                                                      }) => {
    const classes = useStyles(showText);

    const i18n = useI18nContext();
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    const store = new ArticleStockStore(commonContext, articleId);

    if (!userStore.hasAccess(Access.GET_ARTICLE_STOCK.valueOf())) {
        return <></>
    }

    const handleOnclick = async () => {
        await store.openModal();
        onClick();
    }

    const onCloseModal = () => {
        store.closeModal();
    }

    const onPaginationChange = async (page: number, pageSize: number) => {
        await store.goToPage(page, pageSize);
    }

    const text = 'Inventario de Artículo';
    const Icon = InventoryIcon;
    const Btn = () => {
        if (isLinkText) {
            return <Link text={'Detalles'} onClick={handleOnclick} startIcon={InventoryIcon}></Link>
        }
        if (rounded) {
            return <RoundedButton
                onClick={handleOnclick}
                className={className}
                disabled={disabled}
                tooltip={!showText ? text : ""}
                text={showText ? text : ""}
                type={type}
                icon={showIcon ? <Icon/> : <></>}
            />
        }
        return <Button
            text={showText ? text : ""}
            className={className}
            tooltip={!showText ? text : ""}
            disabled={disabled}
            size={size}
            onClick={handleOnclick}
            type={type}
            startIcon={showIcon ? <Icon/> : <></>}
        />
    }
    return <Observer>
        {() => (
            <>
                <SidePanel loading={store.loading} title={text} onClose={onCloseModal} open={store.isModalOpen}
                    className={classes.modal_container}>
                    <div className={classes.contacts_container}>
                        <Box
                            width={Width.FULL_WIDTH}
                            justifyContent={Alignment.SPACE_BETWEEN}>
                            <ShowSellerBasicInfo autofill name={store.article.name}/>
                            <ShowArticleStock
                                amount={store.articleStocks.reduce(
                                    (total, stock) => total + (stock.amount ?? 0),
                                    0
                                )}
                                assignedAmount={store.assignedArticleStockAmount} />
                        </Box>
                        <div className={classes.body}>
                            {!store.isEmpty &&
                            <div className={classes.contacts_table}>
                                <ShowPagination onChange={onPaginationChange}
                                                elementLabel={'Repartidores'}
                                                pagination={store.pagination}/>
                                <div className={classes.elements_container}>
                                    {store.articleStocks.map((articleStock, i) => (
                                        <div className={classes.contact_info_container}>
                                            <ShowSellerBasicInfo autofill name={articleStock.entityName}/>
                                            <ShowArticleStockLocation location={articleStock.locationType}/>
                                            <div>
                                                <div className={classes.title}>{'Inventario'}</div>
                                                <div className={clsx(
                                                    classes.number,
                                                    ((articleStock.amount ?? 0) >= 0) && classes.positive,
                                                    ((articleStock.amount ?? 0) < 0) && classes.negative,
                                                )}>{articleStock.amount ?? 0}</div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <ShowPagination
                                    onChange={onPaginationChange}
                                    elementLabel={'Repartidores'}
                                    pagination={store.pagination}/>
                            </div>
                            }
                            {store.isEmpty &&
                            <MessageCard icon={InventoryIcon} title={i18n.translate("NO_ARTICLE_STOCK_TITLE")}/>}
                        </div>
                    </div>
                </SidePanel>
                <Btn/>
            </>
        )}
    </Observer>
}

export default ArticleStockButton;
